export default function accountWishlistCtrl($scope, $http, $rootScope) {
    var accountScope = angular.element('#account-wrap').scope();

    $scope.inWishlist = function (variant_id) {

        var found = false;
        for (var i = 0; i < $rootScope.wishlist.length; i++) {
            if ($rootScope.wishlist[i].variant_id == variant_id) {
                found = true;
                break;
            }
        }
        return found;
    }

    //Add To Wishlist
    $scope.addToWishlist = function (variant_id, product_id) {
        $(".add-to-wishlist").removeClass("active");
        $rootScope.showOverlay('product-content-' + variant_id);
        $http({
            method: "POST",
            url: "/" + window.Laravel.code + "/wishlist/add-remove",
            data: {
                _token: window.Laravel.csrfToken,
                variant_id: variant_id,
                product_id: product_id,
            }
        }).then(function success(response) {
            var data = response.data;
            console.log('Add To Wishlist Success: ', data);
            accountScope.getUserWishlist();
            $rootScope.hideOverlay('product-content-' + variant_id);
            $rootScope.wishlist.push(variant_id);
        }, function error(response) {
            var data = response.data;
            console.log('Add To Wishlist Error: ', data);
            accountScope.getUserWishlist();
            $rootScope.hideOverlay('product-content-' + variant_id);
        })
        // $rootScope.getUserWishlist();
    };

    $scope.addToCartFromWishlist = function (product_id, variant_id) {
        $http({
            method: "POST",
            url: "/" + window.Laravel.code + "/cart/add",
            data: $rootScope.params({
                _token: window.Laravel.code,
                product_id: product_id,
                variant_id: variant_id
            }),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
        }).then(function success(response) {
            var data = response.data;
            $rootScope.session = data;
            $scope.removeFromWishlist(variant_id);
        }, function error(response) {
            var data = response.data;
            $rootScope.session.order.cart = data.cart;
            console.log('Error: ', data);
        });
    };

    $scope.removeFromWishlist = function (id) {
        $http({
            method: "POST",
            url: "/" + window.Laravel.code + "/wishlist/add-remove",
            data: {
                _token: window.Laravel.csrfToken,
                variant_id: id
            }
        }).then(function success(response) {
            var data = response.data;
            if (data.success == 1) {
                accountScope.getUserWishlist();
            }
            accountScope.getUserWishlist();
        }, function error(response) {
            var data = response.data;
            console.log('Error: ', data);

        });
    };

    $scope.emptyWishlist = function () {
        $http({
            method: "GET",
            url: "/" + window.Laravel.code + "/wishlist/empty-wishlist"
        }).then(function success(response) {
            var data = response.data;
            accountScope.getUserWishlist();
            $rootScope.wishlist = [];
        }, function error(response) {
            var data = response.data;
            console.log('Error: ', data);

        });
    };


}

accountWishlistCtrl.$inject = ['$scope', '$http', '$rootScope'];